// Instafeed app initialization helper
// Ensures the instafeed app loads properly on first page load
(function() {
  'use strict';
  
  // Wait for instafeed to be available
  function ensureInstafeedLoaded() {
    // Check if instafeed container exists
    const instafeedContainer = document.querySelector('[class*="instafeed"], [id*="instafeed"]');
    
    if (!instafeedContainer) {
      return; // No instafeed on this page
    }
    
    // Mark the container to prevent lazy loading interference
    instafeedContainer.setAttribute('data-app-block', 'instafeed');
    
    // Force immediate load of any images in the instafeed container
    const images = instafeedContainer.querySelectorAll('img[data-src], img[loading="lazy"]');
    images.forEach(img => {
      if (img.dataset.src) {
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
      }
      if (img.dataset.srcset) {
        img.srcset = img.dataset.srcset;
        img.removeAttribute('data-srcset');
      }
      // Remove lazy loading attribute
      if (img.getAttribute('loading') === 'lazy') {
        img.removeAttribute('loading');
      }
    });
    
    // Check if instafeed has loaded content
    function checkInstafeedContent() {
      const hasContent = instafeedContainer.querySelector('img, .instafeed-item, [class*="feed"]');
      return hasContent !== null;
    }
    
    // If no content after delay, try to trigger refresh
    let checkCount = 0;
    const maxChecks = 10;
    
    function verifyInstafeedLoad() {
      checkCount++;
      
      if (checkInstafeedContent()) {
        // Content loaded successfully
        console.log('Instafeed loaded successfully');
        return;
      }
      
      if (checkCount < maxChecks) {
        // Keep checking
        setTimeout(verifyInstafeedLoad, 300);
      } else {
        // After multiple checks, if still no content, try to reinitialize
        console.log('Instafeed: attempting to reinitialize');
        
        // Try to find and trigger any instafeed initialization functions
        if (window.Instafeed && typeof window.Instafeed === 'function') {
          try {
            // Reinitialize if the constructor is available
            const feed = new window.Instafeed({
              target: instafeedContainer
            });
            feed.run();
          } catch (e) {
            console.warn('Instafeed reinitialization failed:', e);
          }
        }
        
        // Dispatch a custom event that instafeed might be listening for
        const event = new CustomEvent('instafeed:init', {
          bubbles: true,
          detail: { container: instafeedContainer }
        });
        instafeedContainer.dispatchEvent(event);
      }
    }
    
    // Start verification after a short delay to allow instafeed to initialize
    setTimeout(verifyInstafeedLoad, 500);
  }
  
  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureInstafeedLoaded);
  } else {
    ensureInstafeedLoaded();
  }
  
  // Also listen for Shopify section events (in case section is reloaded)
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('[class*="instafeed"]')) {
      setTimeout(ensureInstafeedLoaded, 100);
    }
  });
  
})();
